import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AllowedPage {
    path: string;
    name: string;
}

interface AllowedPagesContextType {
    allowedPages: AllowedPage[];
    setAllowedPages: (pages: AllowedPage[]) => void;
    clearAllowedPages: () => void;
    isPageAllowed: (path: string) => boolean;
}

const AllowedPagesContext = createContext<AllowedPagesContextType | undefined>(undefined);

interface AllowedPagesProviderProps {
    children: ReactNode;
}

export const AllowedPagesProvider: React.FC<AllowedPagesProviderProps> = ({ children }) => {
    const [allowedPages, setAllowedPagesState] = useState<AllowedPage[]>(() => {
        try {
            const stored = localStorage.getItem('allowedPages');
            return stored ? JSON.parse(stored) : [];
        } catch {
            return [];
        }
    });

    // Wrapper function to update both state and localStorage
    const setAllowedPages = (pages: AllowedPage[]) => {
        setAllowedPagesState(pages);
        localStorage.setItem('allowedPages', JSON.stringify(pages));
    };

    // Clear allowed pages (useful for logout)
    const clearAllowedPages = () => {
        setAllowedPagesState([]);
        localStorage.removeItem('allowedPages');
    };

    const isPageAllowed = (path: string) => {
        // if (allowedPages.length === 0) {
        //     return true;
        // }
        return allowedPages.some(page => page.path === path);
    };

    return (
        <AllowedPagesContext.Provider value={{
            allowedPages,
            setAllowedPages,
            clearAllowedPages,
            isPageAllowed
        }}>
            {children}
        </AllowedPagesContext.Provider>
    );
};

export const useAllowedPages = () => {
    const context = useContext(AllowedPagesContext);
    if (context === undefined) {
        throw new Error('useAllowedPages must be used within an AllowedPagesProvider');
    }
    return context;
};
